import type { DialogPublicInfo } from '@/types/dialog';

// The intro page shows only when there is no conversation to resume. The two
// state errors differ: a version_mismatch genuinely restarts the conversation
// (loadSession replays only the latest version epoch, so the old history
// cannot resurrect), which is exactly the first-timer case the intro exists
// for; load_failed is a transient read error over a conversation that usually
// still exists, so a returning respondent must not be greeted as a first-timer.
export function shouldShowIntro(info: DialogPublicInfo): boolean {
  const state = info.state;
  if (!state) return true;
  if ('error' in state) return state.error === 'version_mismatch';
  return state.messages.length === 0;
}
